import {
    openDB,
} from 'idb';
import { eventBus } from '@/eventBus';

const databaseName = 'zypone';

const upgradeToVersion5 = (db) => {
    if (db.objectStoreNames.contains('assignees')) return;
    db.createObjectStore('assignees', {
        keyPath: 'id',
        autoIncrement: true,
    });
};

export default {

    async open() {
        try {
            this.db = await openDB(databaseName, 5, {
                upgrade(db, oldVersion, newVersion, transaction) {
                    if (oldVersion === 0) {
                        db.createObjectStore('checklists', {
                            keyPath: 'id',
                            autoIncrement: true,
                        });

                        const inspectionStore = db.createObjectStore('inspections', {
                            keyPath: 'id',
                            autoIncrement: true,
                        });
                        inspectionStore.createIndex('user_id', 'user_id');

                        const todoStore = db.createObjectStore('todos', {
                            keyPath: 'id',
                            autoIncrement: true,
                        });
                        todoStore.createIndex('due_at', 'due_at'); // not used anymore, as null values are ignored

                        const draftStore = db.createObjectStore('drafts', {
                            keyPath: 'id',
                            autoIncrement: true,
                        });
                        draftStore.createIndex('user_id', 'user_id');

                        upgradeToVersion5(db);
                    } else if (oldVersion === 1) {
                        if (!db.objectStoreNames.contains('drafts')) {
                            db.createObjectStore('drafts', {
                                keyPath: 'id',
                                autoIncrement: true,
                            });
                        }
                        transaction.objectStore('drafts').createIndex('user_id', 'user_id');
                        transaction.objectStore('inspections').createIndex('user_id', 'user_id');

                        upgradeToVersion5(db);
                    } else if (oldVersion === 2) {
                        transaction.objectStore('drafts').createIndex('user_id', 'user_id');
                        transaction.objectStore('inspections').createIndex('user_id', 'user_id');

                        upgradeToVersion5(db);
                    } else if (oldVersion === 3) {
                        // There was a bug in the migration from version 1, and because of that we need
                        // make sure to have these indexes added if they are not there
                        if (!transaction.objectStore('drafts').indexNames.contains('user_id')) {
                            transaction.objectStore('drafts').createIndex('user_id', 'user_id');
                        }
                        if (!transaction.objectStore('inspections').indexNames.contains('user_id')) {
                            transaction.objectStore('inspections').createIndex('user_id', 'user_id');
                        }

                        upgradeToVersion5(db);
                    } else if (oldVersion === 4) {
                        upgradeToVersion5(db);
                    }
                },
            });
        } catch (error) {
            eventBus.$emit('client-error', { message: window.i18n.t('IndexedDB is not supported by your browser.') });

            /* originally we thought this can only fail in Firefox when in incognito mode. But it seems to fail in
             * safari as well. So we need to log the original error in Sentry so we can see why it fails.
             */
            throw error;
        }
    },

    async clear() {
        if (!this.db) return;
        await Promise.all([
            this.db.clear('assignees'),
            this.db.clear('checklists'),
            this.db.clear('todos'),
        ]);
    },

    async clearStore(store) {
        if (!this.db) return;
        return await this.db.clear(store);
    },

    add(storeName, value) {
        if (!this.db) return;
        return this.db.add(storeName, value);
    },

    put(storeName, value) {
        if (!this.db) return;
        return this.db.put(storeName, value);
    },

    get(storeName, key) {
        if (!this.db) return;
        return this.db.get(storeName, key);
    },

    delete(storeName, key) {
        if (!this.db) return;
        console.log('delete from store', storeName, key);
        return this.db.delete(storeName, key);
    },

    count(storeName) {
        if (!this.db) return;
        return this.db.count(storeName);
    },

    getAll(storeName) {
        if (!this.db) return;
        return this.db.getAll(storeName);
    },

    getAllFromIndex(storeName, indexName) {
        if (!this.db) return;
        return this.db.getAllFromIndex(storeName, indexName);
    },

    getAllKeys(storeName) {
        if (!this.db) return;
        return this.db.getAllKeys(storeName);
    },

    transaction(storeName) {
        if (!this.db) return;
        return this.db.transaction(storeName);
    },

};
